/*!
 * Copyright © 2025 FBSPL. All rights reserved.
 * This script is proprietary and confidential.
 * Unauthorized copying, distribution, or modification is strictly prohibited.
 */
import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { SeoService } from '../../services/seo/seo.service';
import { SeoData } from '../../services/seo/seo-data.model';
import { CdnUrlDirective } from '../../directives/cdn-url.directive';

@Component({
  selector: 'app-careerThankYou',
  standalone: true,
  imports: [RouterLink, CdnUrlDirective],
  templateUrl: './careerThankYou.component.html',
  styleUrl: './careerThankYou.component.css',
})
export class CareerThankyouComponent implements OnInit {
  queryParam: any = {};

  constructor(
    private seoService: SeoService,
    @Inject(PLATFORM_ID) private platformId: Object,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      const seoData: SeoData = {
        title: 'Thank You for Applying to FBSPL',
        description:
          'Thank you for application to FBSPL job opening. We will review it and reach out to you soon.',
        keywords: 'job apply',
        ogImage: '/meta/thankyou.jpg',
      };

      this.seoService.setMetaTags(seoData);
      this.route.queryParams.subscribe((params) => {
        const encodedString = params['q'] || null;
        const decodedString = atob(encodedString);
        this.queryParam = JSON.parse(decodedString);
        console.log('Query parameter q:', this.queryParam);
      });
    }
  }

  copyToClipboard(text: string) {
    if (isPlatformBrowser(this.platformId)) {
      navigator.clipboard
        .writeText(text)
        .then(() => {
          console.log('Text copied to clipboard');
        })
        .catch((err) => {
          console.error('Failed to copy text: ', err);
        });
    }
  }
}
